import { Plus } from "lucide-react";
import { MatterFileRepositoryStructuresTable } from "@/components/features/settings/defaults/matter-file-repository-structures/MatterFileRepositoryStructuresTable";
import { Button, Text } from "@/components/ui";
import { useUser } from "@/components/UserProvider";
import {
  ACTION_PERMISSION_KEYS,
  ACTION_PERMISSION_VALUES,
} from "@/lib/data/static/permissionOptions";
import { useState } from "react";

export default function MatterFileRepositoryStructuresCard() {
  const { hasActionPermission } = useUser();
  const [isAddingFileRepoStructure, setIsAddingFileRepoStructure] =
    useState(false);

  const canCreate = hasActionPermission(
    ACTION_PERMISSION_KEYS.defaultMatterFileRepositoryStructure,
    ACTION_PERMISSION_VALUES.create,
  );

  return (
    <div className="w-full">
      <div className="mb-8 flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
        <div className="gap-y-1">
          <Text variant="title">Default folder structures</Text>
        </div>
        {canCreate ? (
          <Button
            onClick={() => {
              setIsAddingFileRepoStructure(true);
            }}
            variant="foreground"
            size="md"
            className="shrink-0"
          >
            <Plus className="h-4 w-4" aria-hidden="true" />
            Add structure
          </Button>
        ) : null}
      </div>
      <MatterFileRepositoryStructuresTable
        isAddingFileRepoStructure={isAddingFileRepoStructure}
        setIsAddingFileRepoStructure={setIsAddingFileRepoStructure}
        canCreate={canCreate}
      />
    </div>
  );
}
